import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { IonRadioGroup, RadioGroupCustomEvent } from '@ionic/angular';

import { Option } from '../../../models/option.model';

@Component({
  selector: 'mom-form-field-radio',
  templateUrl: './form-field-radio.component.html',
  styleUrls: ['./form-field-radio.component.scss']
})
export class FormFieldRadioComponent implements OnChanges {
  @Input() id: string;
  @Input() formCtrl: UntypedFormControl;
  @Input() label: string;
  @Input() options: Option<unknown>[];

  @ViewChild(IonRadioGroup) viewPort: IonRadioGroup;

  faInfoCircle = faInfoCircle;
  selectedValue: unknown;

  ngOnChanges(): void {
    this.selectedValue = this.formCtrl.value;
    if (this.selectedValue) {
      this.scrollToSelectedOption();
    }
  }

  mapToControl(valueSelected: any): void {
    this.formCtrl.setValue((valueSelected as RadioGroupCustomEvent).detail.value);
  }

  private scrollToSelectedOption(): void {
    setTimeout(() => {
      document.getElementById(`${this.id}-${this.selectedValue}`).scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}
